<template>
	<div class="service">
		<HNB></HNB>
		<div class="title">服务与支持</div>
		<div class="servicebg"><img :src="servicebgimg"></div>
		<div class="box">
			<div class="boxView" >
				<router-link :to="item.name" class="link" v-for="(item,i) in total" :key="i">
						<div class="svgicon">
							<SvgIcon :svg-name="item.svgname" size="60"></SvgIcon>
						</div>
						<p>{{item.intro}}</p>
						
				</router-link>
			</div>
			

		</div>

		<bottom :BsTitle="bstitle"></bottom>
	</div>
</template>

<script>
	import SvgIcon from '../components/SvgIcon.vue'
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	export default {
		name: 'service',
		data() {
			return {
				bstitle: ['服务支持'],
				servicebgimg: this.GLOBAL.imgHost + '/images/service/bg1.png',
				total: [{
						name: '/policy',
						intro: '售后政策',
						svgname: "service"
					},
					{
						name: '/introduction',
						intro: '产品介绍视频',
						svgname: 'movie'
					},
					{
						name: '/download',
						intro: 'APP下载',
						svgname: 'appDownload'
					},
					{
						name: '/relation',
						intro: '联系我们',
						svgname: 'contactUs'
					},

				],
			}
		},
		methods: {

		},
		components: {
			HNB,
			bottom,
			SvgIcon,

		}
	}
</script>

<style>
	.service {
		max-width: 33.75rem;
		margin: 0 auto;
		
	}

	.service .title {
		width: 100%;
		height: 5.75rem;
		font-size: 2rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		line-height: 5.75rem;
	}

	.servicebg {
		width: 85%;
		margin: 0 auto;
		padding-top: 1.875rem;
		padding-bottom: 3.75rem;
	}

	.servicebg img {
		width: 100%;
		height: 100%;
	}
	.box{
		width: 90%;
		margin: 0 auto;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
		padding-bottom: 100px;
		
	}
	
	.box .boxView{
		
		margin: 0 auto;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
		/* padding-bottom: 100px; */
		max-width: 300px;
	}
	
	.box .boxView .link{
		width: 8.25rem;
		height: 8.25rem;
		background:rgba(236,236,236,1);
		margin-bottom: 1rem;
		/* padding-bottom: 1rem; */
		/* padding-top: 1rem; */
	}
	
	.box .boxView .svgicon{
		margin-top: 1.125rem;
	}
	
	.box .boxView .link p{
		font-size:0.9375rem;
		font-family:Alibaba-PuHuiTi-R;
		font-weight:400;
		color:rgba(24,24,24,1);
		padding-top: 0.5rem;
		
	}
	a{
		text-decoration: none;
	}
</style>
